import Button from '../../components/ui/Button'
import { ui } from '../../styles/ui'
import SearchableCurrencySelect from '../../components/ui/SearchableCurrencySelect'

export default function ExchangeRateFilters({ filters, onChange, onApply, onReset, availableBaseCurrencies = [], availableQuoteCurrencies = [] }) {
  return (
    <div className="grid gap-3 rounded-xl border border-outline bg-surface p-3 md:grid-cols-3 lg:grid-cols-4">
      <label className="text-sm">
        <span className="mb-1 block text-xs text-muted-foreground">Base currency</span>
        <SearchableCurrencySelect
          id="exchange-rate-filter-base-currency"
          value={filters.baseCurrency}
          options={availableBaseCurrencies}
          onChange={(value) => onChange('baseCurrency', value)}
          emptyLabel="All"
          searchPlaceholder="Search currency"
          searchAriaLabel="Search base currency"
          selectClassName={ui.forms.select}
        />
      </label>

      <label className="text-sm">
        <span className="mb-1 block text-xs text-muted-foreground">Quote currency</span>
        <SearchableCurrencySelect
          id="exchange-rate-filter-quote-currency"
          value={filters.quoteCurrency}
          options={availableQuoteCurrencies}
          onChange={(value) => onChange('quoteCurrency', value)}
          emptyLabel="All"
          searchPlaceholder="Search currency"
          searchAriaLabel="Search quote currency"
          selectClassName={ui.forms.select}
        />
      </label>

      <label className="text-sm">
        <span className="mb-1 block text-xs text-muted-foreground">Source</span>
        <input
          value={filters.source}
          onChange={(event) => onChange('source', event.target.value)}
          placeholder="ecb"
          className={ui.forms.input}
        />
      </label>

      <label className="text-sm">
        <span className="mb-1 block text-xs text-muted-foreground">Status/Freshness</span>
        <select
          value={filters.status}
          onChange={(event) => onChange('status', event.target.value)}
          className={ui.forms.select}
        >
          <option value="all">All</option>
          <option value="fresh">Fresh</option>
          <option value="stale">Stale</option>
          <option value="missing">Missing</option>
          <option value="failed">Failed</option>
          <option value="unsupported">Unsupported</option>
          <option value="available">Available</option>
        </select>
      </label>

      <label className="text-sm">
        <span className="mb-1 block text-xs text-muted-foreground">Rate date</span>
        <input
          type="date"
          value={filters.rateDate}
          onChange={(event) => onChange('rateDate', event.target.value)}
          className={ui.forms.input}
        />
      </label>

      <label className="text-sm">
        <span className="mb-1 block text-xs text-muted-foreground">Search currency</span>
        <input
          value={filters.search}
          onChange={(event) => onChange('search', event.target.value.toUpperCase())}
          placeholder="USD"
          className={ui.forms.input}
        />
      </label>

      <label className="flex items-center gap-2 text-sm text-foreground">
        <input
          type="checkbox"
          checked={filters.includeDerived}
          onChange={(event) => onChange('includeDerived', event.target.checked)}
          className={ui.forms.checkbox}
        />
        Include derived
      </label>

      <label className="flex items-center gap-2 text-sm text-foreground">
        <input
          type="checkbox"
          checked={filters.usedOnly}
          onChange={(event) => onChange('usedOnly', event.target.checked)}
          className={ui.forms.checkbox}
        />
        Used currencies only
      </label>

      <div className="flex items-end gap-2">
        <Button onClick={onApply}>Apply</Button>
        <Button variant="secondary" onClick={onReset}>Reset</Button>
      </div>
    </div>
  )
}
